export default __webpack_public_path__ + "static/media/CHRON.6a69661e.png";